import { FC } from "react";
import { Card, CardContent, Typography, styled } from "@mui/material";
import { CalculatorSummary } from "../types";
import { grey } from "@mui/material/colors";
import { Link } from "react-router-dom";

const CalculatorLink = styled(Link)({
  textDecoration: "none",
});
const CalculatorCardContainer = styled(Card)({
  width: "22rem", // Three rows
  height: "100%",
  cursor: "pointer",
  ":hover": { backgroundColor: grey[100] },
});

interface CalculatorCardProps {
  calculatorSummary: CalculatorSummary;
}

const CalculatorCard: FC<CalculatorCardProps> = ({
  calculatorSummary: { calculatorId, classification, questionCount },
}) => {
  return (
    <CalculatorLink to={calculatorId}>
      <CalculatorCardContainer variant="outlined">
        <CardContent>
          <Typography variant="h5">{classification}</Typography>
          <Typography variant="body1">{questionCount} questions</Typography>
        </CardContent>
      </CalculatorCardContainer>
    </CalculatorLink>
  );
};

export default CalculatorCard;
